import { gql } from '@apollo/client'

export type PresignedFormData = {
  url: string
  fields: string
}

export type UploadedDealFile = {
  file_upload_id: string
  presigned_url: string
  uploader_person_id: string
  file_name: string
  file_category: string
  content_type: string
  uploader_first_name: string
  uploader_last_name: string
  uploader_is_employee?: boolean
  uploaded_date: string
}

export type UploadedDealFiles = UploadedDealFile[]

export const GET_SIGNED_FILE_UPLOAD_URLS = gql`
  mutation GetSignedFileUploadUrls($input: SignedFileUploadInput!) {
    getSignedFileUploadUrls(input: $input) {
      files {
        content_type
        file_uuid
        file_location
        file_name
        presigned_form_data {
          url
          fields
        }
        file_category
        person_id
      }
    }
  }
`

export const UPLOAD_TRANSACTION_PHOTOS = gql`
  mutation UploadTransactionPhotos($input: FileUploadInput!) {
    uploadTransactionFiles(input: $input) {
      success
    }
  }
`

export const DELETE_PROPERTY_PHOTO = gql`
  mutation DeletePropertyPhoto($input: DeletePropertyPhotoInput!) {
    deletePropertyPhoto(input: $input) {
      success
    }
  }
`

export const GET_UPLOADED_DEAL_FILES = gql`
  query GetUploadedDealFiles($transaction_id: Int!) {
    getUploadedDealFiles(transaction_id: $transaction_id) {
      file_upload_id
      presigned_url
      uploader_person_id
      file_name
      file_category
      content_type
      uploader_first_name
      uploader_last_name
      uploader_is_employee
      uploaded_date
    }
  }
`
